import { createSelector } from '@ngrx/store';
import { notificationsFeature } from '../reducers/notifications.reducer';

export const messengerNotificationsSelector = createSelector(
  notificationsFeature.selectNotifications,
  (notifications) => notifications,
);

export const isMarkAsReadSelector = notificationsFeature.selectIsMarkAsRead;
